import projectsReducer from './features/projects/projectsSlice';
import yearlyTimesheetReducer from './features/monthlysheet/monthlysheetSlice';
import sessionReducer from './features/session/slice';
import timesheetReducer from './features/timesheet/slice';
import userReducer from './features/users/usersSlice';
import poReducer from './features/po/ResourceMapping/Slice';
import receiveReducer from './features/po/ReceiveHours/Slice';
import commonReducer from './features/common/commonSlice';
const rootReducer = {
  timesheet: timesheetReducer,
  yearlyTimesheet: yearlyTimesheetReducer,
  projects: projectsReducer,
  session: sessionReducer,
  users: userReducer,
  po: poReducer,
  receive: receiveReducer,
  common: commonReducer,
};

export default rootReducer;
